function heroSize() {
    const windowHeight = window.innerHeight;
    hero.style.height = windowHeight + "px";
}